/*jshint esversion: 6 */
"use strict";
const EventEmitter = require("events").EventEmitter;
class Tags extends EventEmitter {
    constructor(element) {
        super();
        this.DOMParent = element;
        this.DOMList = undefined;
        this.DOMInput = undefined;
        this.dataAttribute = undefined;
        this.arrayOfList = undefined;

        this._readOnly = false;
        this._disabled = false;

        this.getAttribute();
        this.DOMCreate();
        this.DOMRender();
        this.registerListeners();
    }

    DOMCreate() {
        let ul = document.createElement("ul");
        let input = document.createElement("input");

        this.DOMParent.appendChild(ul);
        this.DOMParent.appendChild(input);

        // first child is <ul>
        this.DOMList = this.DOMParent.firstElementChild;
        // last child is <input>
        this.DOMInput = this.DOMParent.lastElementChild;
    }

    DOMRender() {
        // clear the entire <li> inside <ul>
        this.DOMList.innerHTML = "";

        // render each <li> to <ul>
        this.arrayOfList.forEach((currentValue) => {
            let li = document.createElement("li");
            li.innerHTML = `${currentValue} <a>&times;</a>`;
            // li.querySelector('a').addEventListener( 'click', () => {
            // 	this.onDelete(index);
            // });

            this.DOMList.appendChild(li);
            this.setAttribute();
        });
    }

    _onCloseClick(evt) {
        const index = Array.from(this.DOMList.querySelectorAll("a")).indexOf(evt.target);
        this.onDelete(index);
    }

    _onBlur() {
        let text = this.DOMInput.value;
        if (text.replace(",", "") !== "") {
            this.arrayOfList.push(text.replace(",", ""));
            this.emit("UserValue", this.arrayOfList);
        }
        // clear input
        this.DOMInput.value = "";
        this.DOMRender();
    }

    _onKeyUp(event) {
        let text = this.DOMInput.value;
        // check if ',' or 'enter' key was press
        // console.log(event.keyCode);
        if (text.includes(",") || event.keyCode === 13) {
            // check if empty text when ',' is remove
            if (text.replace(",", "") !== "") {
                // push to array and remove ','
                this.arrayOfList.push(text.replace(",", ""));
                this.emit("UserValue", this.arrayOfList);
            }
            // clear input
            this.DOMInput.value = "";
        }

        if (event.code === "Backspace" || event.keyCode === 8) {
            this.arrayOfList.pop();
            this.emit("UserValue", this.arrayOfList);
        }
        this.DOMRender();
    }

    onDelete(id) {
        this.arrayOfList = this.arrayOfList.filter((currentValue, index) => {
            if (index === id) {
                return false;
            }
            return currentValue;
        });
        this.emit("UserValue", this.arrayOfList);

        this.DOMRender();
    }

    getAttribute() {
        this.dataAttribute = this.DOMParent.getAttribute("data-simple-tags");
        this.dataAttribute = this.dataAttribute ? this.dataAttribute.split(",") : [];

        // store array of data attribute in arrayOfList
        this.arrayOfList = this.dataAttribute.map((currentValue) => {
            return currentValue.trim();
        });
    }

    setAttribute() {
        this.DOMParent.setAttribute("data-simple-tags", this.arrayOfList.toString());
    }

    registerListeners() {
        this.removeListeners();
        this.DOMList.addEventListener(
            "click",
            (this._onCloseClick = this._onCloseClick.bind(this))
        );
        this.DOMInput.addEventListener("keyup", (this._onKeyUp = this._onKeyUp.bind(this)));
        this.DOMInput.addEventListener("blur", (this._onBlur = this._onBlur.bind(this)));
    }

    removeListeners() {
        this.DOMList.removeEventListener("click", this._onCloseClick);
        this.DOMInput.removeEventListener("keyup", this._onKeyUp);
        this.DOMInput.removeEventListener("blur", this._onBlur);
    }

    setReadOnly(bool) {
        if (bool) {
            this.DOMInput.setAttribute("readonly", true);
            this.DOMInput.placeholder = "";
            this.removeListeners();
        } else {
            this.DOMInput.removeAttribute("readonly");
            this.DOMInput.placeholder = this.placeholder || "";
            this.registerListeners();
        }
    }

    setDisabled(bool) {
        if (bool) {
            this.DOMInput.disabled = true;
            this.DOMInput.placeholder = "";
            this.removeListeners();
        } else {
            this.DOMInput.disabled = false;
            this.DOMInput.placeholder = this.placeholder || "";
            this.registerListeners();
        }
    }

    setPlaceholder(val) {
        this.placeholder = val;
        this.DOMInput.placeholder = val;
    }
}

module.exports = class InputTags extends EventEmitter {
    constructor(element) {
        super();
        this.DOMSimpleTags = element;
        this.TagsElement = new Tags(this.DOMSimpleTags);
        this.registerListeners();
    }

    registerListeners() {
        this.TagsElement.on("UserValue", (data) => {
            this.emit("UserValue", data);
        });
    }

    setDisabled(bool) {
        if (bool) {
            this.DOMSimpleTags.classList.add("disabled");
        } else {
            this.DOMSimpleTags.classList.remove("disabled");
        }

        this.TagsElement.setDisabled(bool);
    }

    setFocus(bool) {
        if (bool) {
            this.TagsElement.DOMInput.focus();
        } else {
            this.TagsElement.DOMInput.blur();
        }
    }

    setReadOnly(bool) {
        if (bool) {
            this.DOMSimpleTags.classList.add("readonly");
        } else {
            this.DOMSimpleTags.classList.remove("readonly");
        }
        this.TagsElement.setReadOnly(bool);
    }

    setPlaceholder(val) {
        this.TagsElement.setPlaceholder(val);
    }

    get value() {
        return this.TagsElement.arrayOfList;
    }

    set value(arr) {
        this.TagsElement.arrayOfList = arr;
        this.TagsElement.DOMRender();
    }

    get input() {
        return this.TagsElement.DOMInput;
    }
};
